import { Controller } from "@hotwired/stimulus"

// Fetches a single external value for an external_value field and fills the input
// WITHOUT persisting — works on both new and edit reports. The trigger button is
// type=button so it never submits the report form (no nested form). Auto-fires on
// connect when configured. The value is saved with the normal report form submit.
export default class extends Controller {
  static targets = ["input", "timestamp", "error"]
  static values = {
    url: String,
    typeId: Number,
    reportableType: String,
    reportableId: Number,
    fieldKey: String,
    auto: Boolean,
    loadedLabel: String,
  }

  connect() {
    if (this.autoValue && !this.hasFetched && !this.inputTarget.value) {
      this.fetch()
    }
  }

  async fetch() {
    this.hasFetched = true
    this.clearError()
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const dateField = document.querySelector("#custom_report_report_date")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          Accept: "application/json",
        },
        body: JSON.stringify({
          type_id: this.typeIdValue,
          reportable_type: this.reportableTypeValue,
          reportable_id: this.reportableIdValue,
          field_key: this.fieldKeyValue,
          report_date: dateField?.value || null,
        }),
      })
      const data = await response.json()
      if (response.ok) {
        this.inputTarget.value = data.value ?? ""
        if (this.hasTimestampTarget && data.fetched_at)
          this.timestampTarget.textContent = `${this.loadedLabelValue} ${data.fetched_at}`.trim()
      } else {
        this.showError(data.error)
      }
    } catch (error) {
      this.showError(String(error))
    }
  }

  showError(message) {
    if (this.hasErrorTarget) this.errorTarget.textContent = message || ""
  }

  clearError() {
    if (this.hasErrorTarget) this.errorTarget.textContent = ""
  }
}
